import { jsx as _jsx } from "react/jsx-runtime";
import React, { Suspense } from 'react';
import { AccountAPI } from 'api/account';
import { PageLoading } from 'components/atoms/loading';
import { TokenErrorStatus } from 'components/organisms/token-error/constant';
import { useLoginWithToken } from 'hooks/use-login-with-token';
import { getDecodedEmail, getTokenMeta, isLinkMagicToken } from 'utils/token';
const TokenError = /*#__PURE__*/ React.lazy(()=>import('components/organisms/token-error/token-error').then((d)=>({
            default: d.TokenError
        })));
export const LoginWithToken = ({ token, tokenType })=>{
    const [, isError] = useLoginWithToken(token, tokenType);
    if (isError) {
        // Token may have expired between login.tsx's render check and exec() firing.
        const { decoded, isExpired } = getTokenMeta(token);
        if (isLinkMagicToken(token) && isExpired && decoded) {
            const email = getDecodedEmail(decoded);
            return /*#__PURE__*/ _jsx(Suspense, {
                fallback: /*#__PURE__*/ _jsx(PageLoading, {}),
                children: /*#__PURE__*/ _jsx(TokenError, {
                    status: TokenErrorStatus.Expired,
                    email: email,
                    resendEmail: ()=>AccountAPI.resendMagicLink(token)
                })
            });
        }
        return /*#__PURE__*/ _jsx(Suspense, {
            fallback: /*#__PURE__*/ _jsx(PageLoading, {}),
            children: /*#__PURE__*/ _jsx(TokenError, {
                status: TokenErrorStatus.Invalid
            })
        });
    }
    return /*#__PURE__*/ _jsx(PageLoading, {});
};
